/**
 * URL scheme: voice.akrsmv.net/arch#arch/<level>/<id> — a shareable, reload-restoring deep link
 * into the architecture-map/Setpoint-Atlas navigation position. Mirrors sessionUrl.ts's
 * buildSessionHash/parseSessionHash pattern, scoped to the `/arch` pathname route.
 *
 * `id` may itself contain slashes (e.g. `SE/voice-assistant/composer-state-machine`), and may be
 * empty (the L0 landscape, or the SE/RM/HN index tiers) — buildArchHash omits the trailing slash in
 * that case so the hash stays a clean `#arch/L0` rather than a dangling `#arch/L0/`.
 */

const ARCH_HASH_RE = /^#arch\/(L\d|SE|RM|HN|RB|AD|HG)(?:\/(.+))?$/;

export function buildArchHash(level: string, id: string): string {
  return id ? `#arch/${level}/${id}` : `#arch/${level}`;
}

/** Parse an `#arch/<level>[/<id>]` hash → {level,id}, or null for any other hash (`#s/...`,
 *  `#file:...`, `#chat`, etc.) — the caller (ArchPage) owns deciding what a null result means;
 *  this function's whole job is to NOT claim hashes that belong to another scheme. */
export function parseArchHash(hash: string): { level: string; id: string } | null {
  const m = ARCH_HASH_RE.exec(hash);
  return m ? { level: m[1], id: m[2] ?? '' } : null;
}
